import Swiper from 'swiper';
import forms from './forms/forms';
import routeModal from './route-modal/route-modal';
import videoModal from './video/video-modal';
import addProdToCart from './cart/add-prod';
import impact from './pages/impact';

// Header stuff
import newHeader from './header/new-header';
import headerBanner from './header/header-banner';
import footer from './header/footer';

// Top Navigation
import topNavigation from './vue/top-navigation/top-navigation';

// Lazy Load
import lazyLoadImages from './lazy-load/lazy-load-images';
import lazyLoadVideo from './lazy-load/lazy-load-video';

//Accordion
import accordion from './accordion/accordion';

// Functions
import slideshow from './slideshow/slideshow';
slideshow();

import slideClick from './slide/slide-click';
slideClick();

// Vue Loaders
import delDiaChoice from './vue/del-dia-choice/del-dia-choice';
import delDiaWildcard from './vue/del-dia-choice/del-dia-wildcard';

// Color Map
import colorMap from './vue/color-map/color-map';

//AB TESTS DEL DIA
import ddabbCollectionGrid from './vue/collections/ddabb-collection-grid';
import delDiaProcess from './vue/dd-process/dd-process';

//AB TESTS ALLPA
import allpaabaCollectionGrid from './vue/collections/allpaaba-collection-grid';

//AB TESTS PDP
import pdpTabs from './vue/pdp/pdp-tabs';
import pdpStandard from './vue/pdp/pdp-standard'; 
import pdpDelDia from './vue/pdp/pdp-del-dia';
import pdpDelDiaApparel from './vue/pdp/pdp-del-dia-apparel';
import delDiaSlide from './vue/del-dia-slide/del-dia-slide';
import sizechart from '../vue/pdp/sizechart/sizechart.vue';

import commonThread from './vue/common-thread/common-thread';
import commonThreadArchive from './vue/common-thread/common-thread-archive';
import commonThreadStory from './vue/common-thread/common-thread-story';

//New Standard Collection Grid
import standardCollectionGrid from './vue/collections/standard-collection-grid';
import standardCollectionContainer from './vue/collections/standard-collection-container';
import uptCollectionGrid from './vue/collections/upt-collection-grid';
import uptCollectionContainer from './vue/collections/upt-collection-container';
import collectionHeader from './vue/collections/collection-header';
import productRecommendations from './vue/product-recommendations/product-recommendations';
import yotpoReviews from './vue/yotpo-reviews/yotpo-reviews';
import g4gBlock from './vue/g4g/g4g-block';

//Home Loaders
import homeTestimonials from './vue/home/home-testimonials';
import homeFeaturedProducts from './vue/home/home-featured-products';
import homeFeaturedProductsAB from './vue/home/home-featured-products-ab';

//sidecart
import sidecart from './vue/sidecart/sidecart';
import cart from './vue/cart/cart';

//Forms
import newsletterSignup from './vue/forms/newsletter-signup';
import stickerSignup from './vue/forms/sticker-signup';

//NO LONGER IN USE
//import selectField from './select/select';
//import productOptions from './product-options/product-options';
//import productFeatures from './product-features/product-features';
//import productGridImages from './product-grid-images/product-grid-images';
//import mobileSlider from './mobile-slider/mobile-slider';
//import scrollClick from './functions/scroll-click';
//import countdownTimer from './functions/countdown-timer';
//import parallaxImage from './parallax-image/parallax-image';
//import animate from './animate-in/animate-in';
//import video from './video/video';
//import signupModal from './vue/forms/signup-modal';
//import shoppableTab from './vue/tabs/shoppable-tab';
//import shoppableTab2 from './vue/tabs/shoppable-tab-2';
//import shoppableTab3 from './vue/tabs/shoppable-tab-3';
//import shoppableTab4 from './vue/tabs/shoppable-tab-4';
//import productMeta from './vue/product-meta/product-meta';
//import questivalPackage from './vue/questival-package/questival-package';
//import questivalWhatYouGet from './vue/questival-package/questival-what-you-get';
//import filterableCollectionGrid from './vue/collections/filterable-collection-grid';
//import pdpDdabd from './vue/pdp/pdp-ddabd';
//import pdpAba from './vue/pdp/pdp-aba';
//import functions from './functions/functions';
//import modal from './modal/modal-basic';
//import evergreen from './collections/evergreen';
//import giftGuide from './collections/gift-guide';
